export default String.raw`
.coupons-popup.dialog {
    max-width: 800px;
    width: 100%;
    max-height: 80vh;
    
    .popup__header {
        width: 100%;
        padding: 24px 32px 16px 32px;
        
        .title {
            font-size: 18px;
            font-weight: 600;
            color: $primaryColorFont;
            margin: 0;
        }
        
        form {
            display: flex;
            
            button {
                background: none;
                border: none;
                padding: 4px;
                cursor: pointer;
                color: $labelsColor;
                transition: color 0.2s ease;
                
                &:hover {
                    color: $iconColorsHover;
                }
                
                svg {
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }
    
    .popup__content {
        width: 100%;
        padding: 20px 24px 16px 24px;
        overflow: unset;
        
        .product-info {
            display: flex;
            align-items: center;
            gap: 24px;
            
            .product__image-wrapper {
                width: 80px;
                height: 80px;
                border-radius: 4px;
                overflow: hidden;
                background: $inputsBgColor;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                
                .product-image-container {
                    max-width: 80px;
                    max-height: 80px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    
                    img {
                        max-width: 80px;
                        max-height: 80px;
                        object-fit: contain;
                    }
                }
                
                .no-image-container {
                    width: 80px;
                    height: 80px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    
                    svg {
                        max-width: 80px;
                        max-height: 80px;
                        fill: #D5D5D5;
                    }
                    
                    img.no-image-placeholder {
                        max-width: 50px;
                        max-height: 50px;
                        opacity: 0.6;
                        object-fit: contain;
                    }
                }
                
                .no-image-text {
                    width: 80px;
                    height: 80px;
                    background: $inputsBgColor;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 11px;
                    color: $labelsColor;
                    border: 1px solid $lightBorderColor;
                    border-radius: 4px;
                    text-align: center;
                    line-height: 1.2;
                }
                
                .no-image {
                    width: 100%;
                    height: 100%;
                    max-width: 60px;
                    max-height: 60px;
                }
            }
            
            .product__info {
                flex: 1;
                min-width: 0;
                
                .name-code-container__name {
                    @include h4-headline;
                    color: $primaryColorFont;
                    margin-bottom: 8px;
                }
                
                .name-code-container__code {
                    font-size: 13px;
                    font-weight: 400;
                    color: $labelsColor;
                }
            }
        }
    }
    
    .coupon-popup-body {
        width: 100%;
        flex: 1;
        padding: 0 24px;
        overflow-y: auto;
        background: $bgColor;
        
        .loading-indicator {
            text-align: center;
            padding: 40px 20px;
            color: $labelsColor;
            
            &.hidden {
                display: none;
            }
        }
        
        .tab-content {
            .tab-panel {
                display: block;
            }
        }
        
        .coupons-list-in-popup {
            padding: 0;
            display: none;
            flex-direction: column;
            gap: 12px;

            .no-items {
                text-align: center;
                padding: 40px 20px;
                color: $labelsColor;
                font-size: 14px;
            }
        }
        
        .coupon-item {
            padding: 16px 24px;
            border: 1px solid $lightBorderColor;
            display: flex;
            align-items: center;
            gap: 16px;
            transition: background-color 0.1s ease;
            border-radius: 5px;
            
            .coupon-icon-container {
                width: 32px;
                height: 32px;
                flex-shrink: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: $inputsBgColor;
                border-radius: 8px;
                
                .coupon-icon-js {
                    width: 32px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    
                    .coupon-icon-svg {
                        width: 100%;
                        height: 100%;
                        fill: $secondaryBtnFontColor;
                    }
                }
            }
            
            .coupon-info {
                flex: 1;
            }
            
            .coupon-code-display {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                gap: 4px;
                margin-bottom: 4px;
                
                .copy-code-btn {
                    cursor: pointer;

                    .svgIcon {
                        width: 16px;
                        height: 16px;
                        fill: $iconColors;

                        &:hover {
                            fill: $iconColorsHover;
                        }
                    }
                }
            }
            
            .coupon-type-name {
                 @include body-2-regular;
            }
            
            .code-prefix {
                 @include body-2-regular;
            }

            .coupon-code {
                @include body-2-regular;
                color: $iconColors;
                cursor: pointer;
                transition: color 0.2s ease;

                &:hover {
                    color: $iconColorsHover;
                }
            }
            
          
            
            .coupon-validity {
                @include body-2-regular;
            }
            
            .learn-more-btn {
                @include button;
                cursor: pointer;
            }
            
        }
    }
    
    .coupon-popup-footer {
        width: 100%;
        padding: 20px 32px;
        background: $bgColor;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;

        .close-popup-btn {
            width: 100%;
        }
    }
}
@media (max-width: 1439px) {
    .coupons-popup.dialog {
        margin: auto;
        border-radius: 0;
    }
}
@media (max-width: 767px) {
    .coupons-popup.dialog {
        width: 100%;
        margin: 0;
        height: 100%;
        max-height: 100%;
        
        .popup__header {
            padding: 16px 20px 12px 20px;
        }
        
        .popup__content {
            padding: 16px 20px 12px 20px;
            
            .product-info {
                gap: 12px;
                
                .product__info {
                    .name-code-container__name {
                        font-size: 15px;
                    }
                    
                    .name-code-container__code {
                        font-size: 12px;
                    }
                }
            }
        }
        
        .coupon-popup-body {
            .coupon-item {
                padding: 14px 20px;
                flex-direction: column;
                align-items: flex-start;
                gap: 10px;
            }
        }
        
        .coupons-skeleton-loader {
            .coupon-skeleton-item {
                padding: 14px 20px;
                flex-direction: column;
                align-items: flex-start;
                gap: 10px;
                
                .skeleton-info {
                    width: 100%;
                    
                    .skeleton-validity {
                        margin-left: 0;
                    }
                }
                
                .skeleton-button {
                    width: 100%;
                }
            }
        }
        
        .coupon-popup-footer {
            padding: 16px 20px;
            
            .close-popup-btn {
                width: 100%;
                padding: 14px 32px;
            }
        }
    }
}

@keyframes skeleton-loading {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}


.coupons-skeleton-loader {
    display: none;
    padding: 0;
    
    .coupon-skeleton-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 16px 24px;
        border: 1px solid $lightBorderColor;
        border-radius: 5px;
        margin-bottom: 12px;
        background: $bgColor;
        
        .skeleton-info {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 8px;
            
            .skeleton-first-row {
                display: flex;
                align-items: center;
                gap: 12px;
                
                .skeleton-icon {
                    width: 32px;
                    height: 32px;
                    border-radius: 8px;
                    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                    background-size: 200% 100%;
                    animation: skeleton-loading 2s ease-in-out infinite;
                    flex-shrink: 0;
                }
                
                .skeleton-line {
                    height: 12px;
                    border-radius: 4px;
                    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                    background-size: 200% 100%;
                    animation: skeleton-loading 2s ease-in-out infinite;
                    
                    &.skeleton-type {
                        width: 80px;
                        height: 14px;
                    }
                    
                    &.skeleton-code {
                        width: 120px;
                        height: 14px;
                    }
                }
            }
            
            .skeleton-validity {
                height: 10px;
                width: 150px;
                border-radius: 4px;
                background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                background-size: 200% 100%;
                animation: skeleton-loading 2s ease-in-out infinite;
                margin-left: 44px;
            }
        }
        
        .skeleton-button {
            width: 100px;
            height: 36px;
            border-radius: 4px;
            background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
            background-size: 200% 100%;
            animation: skeleton-loading 2s ease-in-out infinite;
            flex-shrink: 0;
        }
    }
}

.product-coupons-skeleton-loader {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    gap: 8px;

    .product-coupon-skeleton-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 16px;
        border: 1px solid $lightBorderColor;
        background: $bgColor;
        flex: 1 1 calc(50% - 4px);
        
        .skeleton-icon {
            width: 28px;
            height: 28px;
            border-radius: 6px;
            background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
            background-size: 200% 100%;
            animation: skeleton-loading 2s ease-in-out infinite;
            flex-shrink: 0;
        }
        
        .skeleton-content {
            flex: 1;
            
            .skeleton-line {
                height: 12px;
                border-radius: 4px;
                background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                background-size: 200% 100%;
                animation: skeleton-loading 2s ease-in-out infinite;
                
                &.skeleton-name {
                    width: 60%;
                    height: 14px;
                }
            }
        }
    }
}

.product-coupons-list {
    .product-coupons-items {
        display: none;
    }
    
    .product-coupon-item {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 16px;
        margin-bottom: 8px;
        border: 1px solid $lightBorderColor;
        
        .coupon-icon-container {
            width: 28px;
            height: 28px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: $bgColor;
            border-radius: 6px;
            border: 1px solid $lightBorderColor;

            .coupon-icon-js {
                width: 16px;
                height: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                
                .coupon-icon-svg {
                    width: 100%;
                    height: 100%;
                    fill: $secondaryBtnFontColor;
                }
            }
            
            &:hover {
                .coupon-icon-svg {
                    fill: $secondaryBtnHoverFontColor;
                }
            }
        }
        
        .coupon-content {
            flex: 1;
            
            .coupon-name {
                @include body-1-medium;
                color: $primaryColorFont;
                margin-bottom: 2px;
            }
            
            .coupon-discount {
                @include body-2-semibold;
                color: $successColor;
                margin-bottom: 2px;
            }
            
            .coupon-validity {
                font-size: 11px;
                color: $labelsColor;
            }
        }
    }
}

`